var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRank3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 82,
  height: 103,
  viewBox: "0 0 82 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ddd_1_369)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_1_369)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.482 59.026C32.0447 61.2127 31.826 62.962 31.826 64.274C31.826 66.0233 32.1813 67.3353 32.892 68.21C33.6573 69.03 34.942 69.44 36.746 69.44C38.386 69.44 39.78 69.0573 40.928 68.292C42.076 67.472 42.978 66.4333 43.634 65.176C44.3447 63.864 44.864 62.4153 45.192 60.83C45.52 59.2447 45.684 57.632 45.684 55.992C45.684 54.2973 45.2467 52.9033 44.372 51.81C43.552 50.7167 41.9667 50.17 39.616 50.17H35.68L37.32 42.462H41.174C42.65 42.462 43.9347 42.0793 45.028 41.314C46.176 40.5487 47.1327 39.5647 47.898 38.362C48.6633 37.1047 49.2373 35.7653 49.62 34.344C50.0027 32.868 50.194 31.4193 50.194 29.998C50.194 28.4127 49.8113 27.292 49.046 26.636C48.2807 25.98 47.16 25.652 45.684 25.652C44.4267 25.652 43.3607 25.898 42.486 26.39C41.6113 26.8273 40.846 27.4833 40.19 28.358C39.5887 29.178 39.0967 30.162 38.714 31.31C38.3313 32.458 38.0033 33.7153 37.73 35.082H26.906C28.1087 29.2873 30.432 24.996 33.876 22.208C37.3747 19.3653 41.9393 17.944 47.57 17.944C52.1073 17.944 55.5787 18.8187 57.984 20.568C60.3893 22.3173 61.592 25.0507 61.592 28.768C61.592 31.064 61.264 33.1687 60.608 35.082C60.0067 36.9953 59.1593 38.69 58.066 40.166C57.0273 41.5873 55.77 42.79 54.294 43.774C52.818 44.7033 51.26 45.332 49.62 45.66V45.824C52.4627 46.316 54.4853 47.382 55.688 49.022C56.9453 50.6073 57.574 52.63 57.574 55.09C57.574 57.058 57.246 59.3267 56.59 61.896C55.934 64.4653 54.7313 66.8707 52.982 69.112C51.2873 71.3533 48.9093 73.2667 45.848 74.852C42.8413 76.3827 38.96 77.148 34.204 77.148C29.5573 77.148 26.086 76.082 23.79 73.95C21.5487 71.7633 20.428 68.702 20.428 64.766C20.428 63.1807 20.6467 61.3493 21.084 59.272L21.166 59.026H32.482Z",
  fill: "#FAFAFA"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ddd_1_369",
  x: -4,
  y: 0.94397,
  width: 85.592,
  height: 101.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_369"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_1_369",
  result: "effect2_dropShadow_1_369"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_1_369",
  result: "effect3_dropShadow_1_369"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect3_dropShadow_1_369",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_1_369",
  x: 16.428,
  y: 17.944,
  width: 49.1641,
  height: 67.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_369"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1_369",
  result: "shape"
})))));
export default SvgRank3;